// Estado do corpo da tabela de "Reprocessar Pagamentos".
//
// Invariantes:
// - Enquanto houver carregamento em andamento — carga inicial (isLoading)
//   OU refetch (isFetching, ex.: botão "Atualizar") — o corpo exibe SEMPRE
//   as linhas de skeleton, substituindo as linhas de dados.
// - O empty state ("Nenhum caso encontrado") só aparece quando NÃO há
//   carregamento em andamento e a lista veio vazia.

export type TableBodyState = "skeleton" | "rows" | "empty"

// Resolve o que o corpo da tabela deve renderizar.
export const resolveTableBodyState = (
  isLoading: boolean,
  isFetching: boolean,
  paymentCount: number
): TableBodyState => {
  if (isLoading || isFetching) return "skeleton"
  return paymentCount > 0 ? "rows" : "empty"
}
